import { api } from '../services/axiosConfig';
import { SystemIntel } from '../types';

export const fetchCurrentSystemIntel = () =>
  api.get<SystemIntel>('/api/intel/current-system').then((r) => r.data);

export const fetchSystemIntel = (solarSystemId: number) =>
  api.get<SystemIntel>(`/api/intel/system/${solarSystemId}`).then((r) => r.data);
